import { RegisterOptions } from 'react-hook-form';
import BaseInput from '../../Form/BaseInput';
export interface TextAreaInputProps extends ITextAreaField {
  rules?: RegisterOptions;
  rows?: number;
}
export const TextAreaInput = ({
  name,
  placeholder,
  rules,
  rows = 5,
  ...rest
}: TextAreaInputProps) => {
  return (
    <>
      <BaseInput name={name} {...rest}>
        {({ register }) => (
          <textarea
            {...register(name, rules)}
            className=" form-control block w-full rounded-xl border border-gray-100  p-4 text-sm focus:outline-none focus:shadow placeholder-gray-lighter bg-clip-padding transition ease-in-out m-0 bg-transparent"
            rows={rows}
            placeholder={placeholder}
            defaultValue={''}
          />
        )}
      </BaseInput>
    </>
  );
};
